<template>
  <div id="wrap" v-loading="loading">
    <div class="flex flex-start flex-wrap">
      <div>
        <el-form :inline="true">
          <el-form-item label="姓名：">
            <el-input
              placeholder="请输入"
              v-model="queryParam.employeeName"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-form :inline="true">
          <el-form-item label="部门：">
            <el-select v-model="queryParam.deptName">
              <el-option value="" label="全部"></el-option>
              <el-option
                v-for="item in depts"
                :label="item.deptName"
                :value="item.deptName"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-form :inline="true">
          <el-form-item label="时间：">
            <el-date-picker
              v-model="dateRange"
              type="monthrange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-button type="primary" @click="search"> 查询</el-button>
      </div>
    </div>

    <div class="flex flex-start" style="margin-top: 15px">
      <el-button type="primary" @click="add"
        ><i class="el-icon-plus"></i> 新增</el-button
      >
      <el-button type="primary" @click="dialogFormVisible_daoru = true"
        >批量导入</el-button
      >
    </div>

    <div class="flex flex-justify title_box">
      <div>
        <i class="el-icon-warning" style="color: #4988df">
          已选择 <span>{{ selectLength }}</span> 项
        </i>
      </div>
      <div>
        <el-link
          type="primary"
          style="margin-left: 20px"
          :underline="false"
          @click="batchRemove"
          >删除</el-link
        >
      </div>
    </div>

    <!-- 新增薪资 -->
    <el-dialog
      title="人员薪资信息"
      :visible.sync="add_people_message"
      center
      width="40%"
    >
      <div class="dialog_content" @click="clickFn">
        <p class="text">基本信息</p>
        <el-form
          class="flex flex flex-justify flex-wrap form_box"
          label-position="top"
          :model="salaryForm"
          :rules="rules"
          ref="ruleForm"
        >
          <el-form-item label="姓名：" prop="vo.employeeName">
            <el-input
              placeholder="请输入"
              disabled
              v-model="salaryForm.vo.employeeName"
            ></el-input>
          </el-form-item>
          <el-form-item label="工号：" prop="vo.employeeNumber">
            <el-input
              placeholder="请输入"
              :disabled="disblay"
              v-model="salaryForm.vo.employeeNumber"
              @blur="blurQuery"
            ></el-input>
          </el-form-item>
          <el-form-item label="部门：" prop="vo.deptName">
            <el-select v-model="salaryForm.vo.deptName" disabled>
              <el-option
                v-for="item in depts"
                :key="item.deptName"
                :value="item.deptName"
                :label="item.deptName"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="项目：" prop="vo.projectId">
            <el-select v-model="salaryForm.vo.projectId" disabled>
              <el-option v-for="item in projects" :label="item.projectName" :key="item.id" :value="item.id"></el-option>
            </el-select>
          </el-form-item> -->
        </el-form>
        <p class="text">项目</p>
        <el-form
          class="flex flex flex-justify flex-wrap form_box"
          label-position="top"
          :model="salaryForm"
          :rules="rules"
          ref="ruleForm"
        >
          <el-form-item label="项目：" prop="vo.projectId">
            <el-select v-model="salaryForm.vo.projectId" disabled>
              <el-option
                v-for="item in projects"
                :label="item.projectName"
                :key="item.id"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <p class="text">薪资</p>
        <el-form
          class="flex flex flex-justify flex-wrap form_box"
          label-position="top"
          :model="salaryForm"
          :rules="rules"
          ref="ruleForm"
        >
          <el-form-item label="薪资时间：" prop="vo.salaryMonth">
            <el-date-picker
              v-model="salaryForm.vo.salaryMonth"
              type="month"
              value-format="yyyy-MM"
              placeholder="选择时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="薪资：" prop="vo.salary">
            <el-input
              placeholder="请输入"
              v-model="salaryForm.vo.salary"
            ></el-input>
          </el-form-item>
          <el-form-item label="五险：" prop="vo.fiveSocial">
            <el-input
              placeholder="请输入"
              v-model="salaryForm.vo.fiveSocial"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="公积金："
            prop="vo.accumulationFund"
            aria-placeholder="请选择"
          >
            <el-input
              placeholder="请输入"
              v-model="salaryForm.vo.accumulationFund"
            ></el-input>
          </el-form-item>
        </el-form>
        <p class="text">奖金</p>
        <div style="position: relative">
          <i class="gsadd el-icon-circle-plus-outline" @click="grAdd"></i>
          <el-table
            class="table"
            :data="salaryForm.boList"
            :header-cell-style="{ background: '#cccccc' }"
            :row-class-name="tableRowClassName"
          >
            <el-table-column width="60" label="">
              <template slot-scope="scope">
                <i
                  class="el-icon-remove"
                  style="color: #747474"
                  @click="grDelete(scope.$index, salaryForm.boList)"
                ></i>
              </template>
            </el-table-column>
            <el-table-column label="类型" prop="bonusType">
              <template slot-scope="scope">
                <el-select v-model="scope.row.bonusType">
                  <el-option
                    v-for="item in boundsTypes"
                    :key="item.dictCode"
                    :value="item.dictCode"
                    :label="item.dictName"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="奖金（元)" prop="bonusAmount">
              <template slot-scope="scope">
                <el-input v-model="scope.row.bonusAmount"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="quxiao">返 回</el-button>
        <el-button type="primary" @click="saveSalary" v-loading="loading"
          >保 存</el-button
        >
      </div>
    </el-dialog>

    <!-- 导入 -->
    <el-dialog
      title="批量导入"
      :visible.sync="dialogFormVisible_daoru"
      center
      width="44%"
    >
      <div class="dialog_content">
        <div class="download" style="margin-top: 20px; line-height: 25px">
          <div>填写需要导入的数据</div>
          <div style="color: #a3adb9">
            请按照数据模板的格式准备导入数据,模板中的表头名称不可更改,表头行不能删除,表格格式不能修改
          </div>
          <div>
            <el-link type="primary" :underline="false" @click="importTemplate"
              >下载模板</el-link
            >
          </div>
        </div>
        <div class="upload" style="margin-top: 20px; line-height: 25px">
          <div>上传填好的表格</div>
          <div style="color: #a3adb9">
            文件后缀名必须为xls或xsx (即Excel格式) ,文件大小不得大于5M
          </div>
          <el-upload
            class="upload-demo"
            :action="salaryImportUrl"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            multiple
            ref="upload"
            :limit="1"
            :on-exceed="handleExceed"
            :on-success="uploadSuccess"
            :data="{ projectId: queryParam.projectId }"
            :file-list="fileList"
          >
            <el-link type="primary" :underline="false">上传文件</el-link>
          </el-upload>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible_daoru = false"
          >关 闭</el-button
        >
        <el-button type="primary" @click="dialogFormVisible_daoru = false"
          >保 存</el-button
        >
      </div>
    </el-dialog>

    <el-table
      class="table"
      :data="tableData"
      ref="salaryTable"
      @selection-change="tableSelect"
      :header-cell-style="{ background: '#F5F7FA' }"
      stripe
      :row-class-name="tableRowClassName"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        label="姓名"
        width="120"
        prop="employeeName"
      ></el-table-column>
      <el-table-column
        prop="salaryMonth"
        label="日期"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="员工工号"
        width="120"
        prop="employeeNumber"
      ></el-table-column>
      <el-table-column
        label="部门"
        width="180"
        prop="deptName"
      ></el-table-column>
      <el-table-column label="工资" prop="salary"></el-table-column>
      <el-table-column label="五险" prop="fiveSocial"></el-table-column>
      <el-table-column label="公积金" prop="accumulationFund"></el-table-column>

      <el-table-column label="奖金" prop="bonusAmount"></el-table-column>
      <el-table-column
        label="操作人员"
        width="150"
        prop="createUserId"
      ></el-table-column>
      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            class="green"
            @click="edit(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="small"
            class="red"
            @click="removeSalary(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="flex flex-end">
      <el-pagination
        class="pagination"
        background
        :current-page.sync="queryParam.pageNum"
        :page-size.sync="queryParam.pageSize"
        :total="total"
        @current-change="search"
      >
      </el-pagination>
    </div>
    <import-tips
      :show="importOpen"
      :data="importData"
      :succeedNumber="importSucceedNumber"
      :errorNumber="importErrorNumber"
      @importOpnes="importOpnes"
    />
  </div>
</template>

<script>
import {
  getSalary,
  getDepts,
  getProjectList,
  deleteSalary,
  saveSalary,
  querySalaryBonus,
  queryByNumber,
} from "./project";
import { getDict } from "@/api/ChinaHigh";
import importTips from "./finances/importTips.vue";
import { importDateDownloadTemplate } from "./fixedAssets";
export default {
  components: {
    importTips,
  },
  data() {
    return {
      salaryImportUrl: this.mainBaseURL + "/importDate/importSalary",
      loading: false,
      fileList: [],
      dateRange: [],
      queryParam: {
        employeeName: "",
        beginTime: "",
        endTime: "",
        projectId: "",
        pageNum: 1,
        pageSize: 10,
      },
      salaryForm: {
        boList: [],
        vo: {},
      },
      selectLength: 0,
      // 导入
      dialogFormVisible_daoru: false,
      // 关联人员
      dialogFormVisible_add: false,
      // 新增
      add_people_message: false,

      radio: "1",
      input1: "",
      value1: "",
      ruleForm: {
        name: "",
      },
      rules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      timer: false,
      ids: [],
      depts: [],
      projects: [],
      tableData: [],
      total: 0,
      disblay: false,
      importOpen: false,
      importData: [],
      importSucceedNumber: 0,
      importErrorNumber: 0,
      value: "",
      boundsTypes: [],
      options: [
        {
          value: "1",
          label: "产品一部",
          children: [
            {
              value: "2",
              label: "研发部",
              children: [
                {
                  value: "3",
                  label: "软件",
                },
              ],
            },
          ],
        },
      ],
    };
  },
  created() {
    this.init();
  },
  methods: {
    clickFn() {
      this.$forceUpdate();
    },
    blurQuery() {
      if (this.salaryForm.vo.employeeNumber != "") {
        queryByNumber(this.salaryForm.vo.employeeNumber).then((res) => {
          this.salaryForm.vo.employeeName = res.data.employeeName;
          this.salaryForm.vo.deptName = res.data.deptName;
        });
      }
    },
    importTemplate() {
      importDateDownloadTemplate(12).then((res) => {
        if (res.code == "00000") {
          window.open(res.data, "_blank");
        }
      });
    },
    edit(row) {
      querySalaryBonus(row.id).then((res) => {
        res.data.forEach((item) => {
          item.bonusType = parseInt(item.bonusType);
        });
        this.salaryForm.boList = res.data;
        console.log(res);
      });
      this.disblay = true;
      this.salaryForm.vo = row;
      this.add_people_message = true;
    },
    quxiao() {
      this.add_people_message = false;
      this.search();
    },
    add() {
      this.disblay = false;
      this.salaryForm = { vo: {}, boList: [] };
      this.salaryForm.vo.projectId =
        sessionStorage.getItem("zt_jjkc_project_id");
      this.add_people_message = true;
    },
    saveSalary() {
      this.loading = true;
      saveSalary(this.salaryForm).then((res) => {
        this.loading = false;
        if (res.code == "00000") {
          this.msgSuccess("保存成功");
          this.add_people_message = false;
          this.search();
        }
      });
    },
    batchRemove() {
      this.ids = [];
      this.$refs.salaryTable.selection.forEach((item) => {
        this.ids.push(item.id);
      });
      if (this.ids.length <= 0) {
        this.$message.error("请至少选中一个");
        return;
      }
      this.$confirm("确认删除吗?", "警告", { type: "warning" }).then((ok) => {
        if (ok) {
          deleteSalary(this.ids).then((res) => {
            if (res.code == "00000") {
              this.msgSuccess("删除成功");
              this.search();
            }
          });
        }
      });
    },
    tableSelect(selection) {
      this.selectLength = selection.length;
      console.log(this.selectLength);
    },
    init() {
      this.salaryForm.vo.projectId =
        sessionStorage.getItem("zt_jjkc_project_id");
      this.queryParam.projectId = sessionStorage.getItem("zt_jjkc_project_id");
      //获取部门
      getDepts().then((res) => {
        this.depts = res.data;
      });
      //获取项目
      getProjectList().then((res) => {
        this.projects = res.data;
      });
      //获取奖金类型
      getDict({ type: "bounds_type" }).then((res) => {
        this.boundsTypes = res.data;
      });
      this.search();
    },
    removeSalary(id) {
      this.$confirm("确认删除吗?", "警告", { type: "warning" }).then((ok) => {
        if (ok) {
          this.ids = [];
          this.ids.push(id);
          deleteSalary(this.ids).then((res) => {
            if (res.code == "00000") {
              this.msgSuccess("删除成功");
              this.search();
            }
          });
        }
      });
    },
    search() {
      this.queryParam.pageNum = 1;
      this.queryParam.pageSize = 10;
      if (
        this.dateRange !== null &&
        this.dateRange != "" &&
        this.dateRange.length > 0
      ) {
        this.queryParam.beginTime = this.dateRange[0];
        this.queryParam.endTime = this.dateRange[1];
      } else {
        this.queryParam.beginTime = "";
        this.queryParam.endTime = "";
      }
      this.loading = true;
      getSalary(this.queryParam).then((res) => {
        this.loading = false;
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "background:#fff";
      } else {
        return "background:#F5F7FA";
      }
    },
    handleRemove(file, fileList) {},
    handlePreview(file) {},
    handleExceed(files, fileList) {
      this.$message.error("超出限制文件个数");
    },
    beforeRemove(file, fileList) {},

    grDelete(index, rows) {
      rows.splice(index, 1);
    },
    grAdd() {
      this.salaryForm.boList.push({});
    },
    uploadSuccess(res, file) {
      if (res.code == "00000") {
        this.dialogFormVisible_daoru = false;
        this.$refs.upload.clearFiles();
        this.importOpen = true;
        this.importData = res.data.errorList;
        this.importSucceedNumber = res.data.succeedNumber;
        this.importErrorNumber = res.data.errorNumber;
        this.search();
      } else {
        this.$refs.upload.abort();
        this.$message.error(res.msg);
      }
    },
    importOpnes() {
      this.importOpen = false;
      this.importData = [];
      this.importSucceedNumber = 0;
      this.importErrorNumber = 0;
    },
  },
};
</script>
<style scoped>
.title_box {
  width: 100%;
  height: 40px;
  background-color: #e6f7ff;
  box-shadow: rgba(186, 231, 255, 1) solid 1px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 40px;
  padding: 0 20px;
  box-sizing: border-box;
  margin: 20px 0;
}
.form_box .el-form-item {
  width: 46%;
}
.text {
  font-size: 14px;
  padding: 10px 20px;
  position: relative;
  border-bottom: 1px solid #dbdbdb;
  margin-bottom: 20px;
}
.text::before {
  content: "";
  position: absolute;
  width: 4px;
  height: 18px;
  left: 10px;
  top: 10px;
  background: #7c99fd;
}
.gsadd {
  position: absolute;
  left: 17px;
  top: 20px;
  z-index: 9;
}
</style>
